module.exports = __webpack_public_path__ + "assets/26457094116309bb36171636ac0b4554.mp3";